"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-misused-promises */
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_1 = __importStar(require("react"));
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var icons_material_1 = require("@mui/icons-material");
var react_hook_form_1 = require("react-hook-form");
var AxiosClient_1 = require("../../utils/AxiosClient");
var functions_1 = require("../../interfaces/functions");
var EditProfile = function () {
    var _a;
    var _b = (0, react_1.useState)(false), inAction = _b[0], setAction = _b[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, react_hook_form_1.useForm)(), register = _c.register, handleSubmit = _c.handleSubmit, watch = _c.watch, errors = _c.formState.errors, setValue = _c.setValue;
    var _d = (0, react_1.useState)(), initialValues = _d[0], setInitialValues = _d[1];
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var userId, response, sellerData, initialValues;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        userId = localStorage.getItem("userId");
                        return [4 /*yield*/, AxiosClient_1.AxiosClient.get("/profile/".concat(userId))];
                    case 1:
                        response = _l.sent();
                        console.log("response data ".concat(response));
                        sellerData = response.data.data;
                        console.log("userData", sellerData);
                        initialValues = {
                            firstName: sellerData.firstName,
                            lastName: sellerData.lastName,
                            email: sellerData.email,
                            phoneNumber: sellerData.phoneNumber,
                            gender: sellerData.gender,
                            birthdate: sellerData.birthdate,
                            language: sellerData.language,
                            streetAddress: ((_a = sellerData.Address) === null || _a === void 0 ? void 0 : _a.streetAddress) || "",
                            city: ((_b = sellerData.Address) === null || _b === void 0 ? void 0 : _b.city) || "",
                            stateOrProvince: ((_c = sellerData.Address) === null || _c === void 0 ? void 0 : _c.stateOrProvince) || "",
                            zipOrPostalCode: ((_d = sellerData.Address) === null || _d === void 0 ? void 0 : _d.zipOrPostalCode) || "",
                            country: ((_e = sellerData.Address) === null || _e === void 0 ? void 0 : _e.country) || "",
                            billingStreetAddress: ((_f = sellerData.billingAddress) === null || _f === void 0 ? void 0 : _f.streetAddress) || "",
                            billingCity: ((_g = sellerData.billingAddress) === null || _g === void 0 ? void 0 : _g.city) || "",
                            billingStateOrProvince: ((_h = sellerData.billingAddress) === null || _h === void 0 ? void 0 : _h.stateOrProvince) || "",
                            billingZipOrPostalCode: ((_j = sellerData.billingAddress) === null || _j === void 0 ? void 0 : _j.zipOrPostalCode) || "",
                            billingCountry: ((_k = sellerData.billingAddress) === null || _k === void 0 ? void 0 : _k.country) || "",
                        };
                        setInitialValues(initialValues);
                        setValue("phoneNumber", initialValues.phoneNumber);
                        setValue("gender", initialValues.gender);
                        setValue("birthdate", initialValues.birthdate);
                        setValue("language", initialValues.language);
                        setValue("streetAddress", initialValues.streetAddress);
                        setValue("city", initialValues.city);
                        setValue("stateOrProvince", initialValues.stateOrProvince);
                        setValue("zipOrPostalCode", initialValues.zipOrPostalCode);
                        setValue("country", initialValues.country);
                        setValue("billingStreetAddress", initialValues.billingStreetAddress);
                        setValue("billingCity", initialValues.billingCity);
                        setValue("billingStateOrProvince", initialValues.billingStateOrProvince);
                        setValue("billingZipOrPostalCode", initialValues.billingZipOrPostalCode);
                        setValue("billingCountry", initialValues.billingCountry);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var naviagetuser = function () {
        var role = (0, functions_1.getCookie)("role");
        if (role == "user") {
            navigate("/profile");
        }
        if (role == "seller") {
            navigate("/seller-home");
        }
        if (role == "admin") {
            navigate("/admin-dashboard");
        }
    };
    var submit = function (data) {
        setAction(true);
        react_hot_toast_1.default.loading("Updating profile");
        var billingAddress = {
            streetAddress: data.billingStreetAddress,
            city: data.billingCity,
            stateOrProvince: data.billingStateOrProvince,
            zipOrPostalCode: data.billingZipOrPostalCode,
            country: data.billingCountry,
        };
        var address = {
            streetAddress: data.streetAddress,
            city: data.city,
            stateOrProvince: data.stateOrProvince,
            zipOrPostalCode: data.zipOrPostalCode,
            country: data.country,
        };
        var profileDetails = {
            phoneNumber: data.phoneNumber,
            gender: data.gender,
            birthdate: data.birthdate,
            language: data.language,
        };
        var token = js_cookie_1.default.get("token");
        AxiosClient_1.AxiosClient.patch("/profile/edit", {
            profileDetails: profileDetails,
            billingAddress: billingAddress,
            address: address,
        }, {
            headers: {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                Authorization: "Bearer ".concat(token),
            },
        })
            .then(function (response) {
            react_hot_toast_1.default.remove();
            react_hot_toast_1.default.success(response.data.message, { duration: 5000 });
            naviagetuser();
        })
            .catch(function (error) {
            setAction(false);
            react_hot_toast_1.default.remove();
            react_hot_toast_1.default.error(error.response.data.message, { duration: 5000 });
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.CssBaseline, null),
        react_1.default.createElement(react_hot_toast_1.Toaster, { position: "top-right", reverseOrder: false }),
        react_1.default.createElement(material_1.Container, { maxWidth: "lg" },
            react_1.default.createElement(material_1.Box, { sx: { my: 4, mx: "auto", maxWidth: 600 } },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 3 },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.Button, { variant: "contained", startIcon: react_1.default.createElement(icons_material_1.ChevronLeft, null), onClick: function () {
                                naviagetuser();
                            } }, "Back Home")),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.Typography, { variant: "h4", component: "h1" }, "Edit your profile")),
                    initialValues && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement("form", { onSubmit: handleSubmit(submit) },
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Phone number", variant: "outlined", margin: "normal", defaultValue: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.phoneNumber) || "" }, register("phoneNumber", {
                                required: true,
                                pattern: {
                                    value: /^\+250\s?\d{3}\s?\d{3}\s?\d{3}$/,
                                    message: "Please enter this format +250780301050.",
                                },
                            }), { error: !!errors.phoneNumber, helperText: (_a = errors.phoneNumber) === null || _a === void 0 ? void 0 : _a.message, disabled: inAction, placeholder: "+250 780 000 000" })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Gender", variant: "outlined", margin: "normal", defaultValue: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.gender) || "" }, register("gender"), { error: !!errors.gender, helperText: errors.gender ? "Gender is required" : "", disabled: inAction, select: true }),
                                react_1.default.createElement(material_1.MenuItem, { value: "male" }, "Male"),
                                react_1.default.createElement(material_1.MenuItem, { value: "female" }, "Female")),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Birthdate", variant: "outlined", margin: "normal" }, register("birthdate"), { defaultValue: initialValues === null || initialValues === void 0 ? void 0 : initialValues.birthdate, error: !!errors.birthdate, helperText: errors.birthdate ? "Birthdate is required" : "", disabled: inAction, type: "date", InputLabelProps: {
                                    shrink: true,
                                } })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Street Address", variant: "outlined", margin: "normal", value: watch("streetAddress") ||
                                    (initialValues && initialValues.streetAddress) || // Check if initialValues is not null
                                    "" }, register("streetAddress"), { error: !!errors.streetAddress, helperText: errors.streetAddress ? "Street Address is required" : "", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "City", variant: "outlined", margin: "normal", value: watch("city") || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.city) || null }, register("city"), { error: !!errors.city, helperText: errors.city ? "City is required" : "", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "State/Province", variant: "outlined", margin: "normal", value: watch("stateOrProvince") ||
                                    (initialValues === null || initialValues === void 0 ? void 0 : initialValues.stateOrProvince) ||
                                    null }, register("stateOrProvince"), { error: !!errors.stateOrProvince, helperText: errors.stateOrProvince && "State/province is required", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Zip/Postal Code", variant: "outlined", margin: "normal", value: watch("zipOrPostalCode") ||
                                    (initialValues === null || initialValues === void 0 ? void 0 : initialValues.zipOrPostalCode) ||
                                    null }, register("zipOrPostalCode"), { error: !!errors.zipOrPostalCode, helperText: errors.zipOrPostalCode && "Zip/postal code is required", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Country", variant: "outlined", margin: "normal", value: watch("country") || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.country) || null }, register("country"), { error: !!errors.country, helperText: errors.country && "Country is required", disabled: inAction })),
                            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                                react_1.default.createElement(material_1.Typography, { variant: "h6", sx: { mb: 2 } }, "Billing Address")),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Billing Street Address", variant: "outlined", margin: "normal", value: watch("billingStreetAddress") ||
                                    (initialValues === null || initialValues === void 0 ? void 0 : initialValues.billingStreetAddress) ||
                                    null }, register("billingStreetAddress"), { error: !!errors.billingStreetAddress, helperText: errors.billingStreetAddress &&
                                    "Billing street address is required", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Billing City", variant: "outlined", margin: "normal", value: watch("billingCity") || (initialValues === null || initialValues === void 0 ? void 0 : initialValues.billingCity) || null }, register("billingCity"), { error: !!errors.billingCity, helperText: errors.billingCity && "Billing city is required", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Billing State/Province", variant: "outlined", margin: "normal", value: watch("billingStateOrProvince") ||
                                    (initialValues === null || initialValues === void 0 ? void 0 : initialValues.billingStateOrProvince) ||
                                    null }, register("billingStateOrProvince"), { error: !!errors.billingStateOrProvince, helperText: errors.billingStateOrProvince &&
                                    "Billing state/province is required", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Billing Zip/Postal Code", variant: "outlined", margin: "normal", value: watch("billingZipOrPostalCode") ||
                                    (initialValues === null || initialValues === void 0 ? void 0 : initialValues.billingZipOrPostalCode) ||
                                    null }, register("billingZipOrPostalCode"), { error: !!errors.billingZipOrPostalCode, helperText: errors.billingZipOrPostalCode &&
                                    "Billing zip/postal code is required", disabled: inAction })),
                            react_1.default.createElement(material_1.TextField, __assign({ fullWidth: true, label: "Billing Country", variant: "outlined", margin: "normal", value: watch("billingCountry") ||
                                    (initialValues === null || initialValues === void 0 ? void 0 : initialValues.billingCountry) ||
                                    null }, register("billingCountry"), { error: !!errors.billingCountry, helperText: errors.billingCountry && "Billing country is required", disabled: inAction })),
                            react_1.default.createElement(material_1.Box, { sx: { textAlign: "left" } },
                                react_1.default.createElement(material_1.Button, { variant: "contained", color: "primary", type: "submit", disabled: inAction, startIcon: react_1.default.createElement(icons_material_1.Save, null) }, inAction ? "Submitting..." : "Save Changes"))))))))));
};
exports.default = EditProfile;
